// @flow
import { PDFFillerContext } from 'pages/Contexts/PdfFillerContext'
import * as React from 'react'
import tw from 'tailwind-styled-components'
import type { InputType } from 'types/input-field'

type Props = {
  label: string,
  value: InputType,
}

const Pill = tw.div`
  flex
  items-center
  cursor-pointer
  border
  rounded
  px-1
  hover:bg-gray-200
  disabled:bg-gray-100/50
  ${(props: { $active: boolean }) => (props.$active ? 'border-primary' : '')}

`

const PillText = tw.div`
  flex-1
  p-1
  text-center
  text-xs
  text-txt-emphasis
`

function InputTypeButton({ label, value }: Props): React.Node {
  const { overlayActive, setOverlayActive } = React.useContext(PDFFillerContext)

  const onClick = () => {
    overlayActive === value ? setOverlayActive(null) : setOverlayActive(value)
  }

  return (
    <Pill $active={overlayActive === value} onClick={onClick}>
      <PillText>{label}</PillText>
    </Pill>
  )
}

export default InputTypeButton
